export const CANCEL_NOT_POSSIBLE = 1;



// WEBPACK FOOTER //
// ./js/constants/BigStakeCancelError.js